export default __webpack_public_path__ + "static/benefits-e4d8caa05a7f13b3ed57b8c3963c6259.png";